//----------Import Dependencies-----------
import React from 'react'
import { Container, Button } from '@mui/material'
//----------Import Components-------------
//----------Import Styles-----------------
import { NavLink } from 'react-router-dom'
import '../../styles/LoginAndUserSelect.css'

export default function UserSelect() {
    return (
        <Container>
            <div>
                <div className="centerText">
                    {/* <span className='userSelectHeading'>Cervi Test</span> */}
                    <img src="./images/logo.png" alt='logo' className='userSelectLogo'/>
                </div>

                <div className="centerText">
                    <NavLink to={{pathname: "/login", userType: "patient"}}>
                        <Button variant="contained" className="loginPageButton">
                            I am a Patient
                        </Button>
                    </NavLink>
                    <br/>

                    <NavLink to={{pathname: "/login", userType: "doctor"}}>
                        <Button variant="contained" className="loginPageButton">
                            I am a Doctor
                        </Button>
                    </NavLink>
                    <br/>

                    <Button variant="contained" className="loginPageButton">
                        I am a Health Professional
                    </Button>
                    <br/>
                </div>

            </div>   
        </Container>

    )
}